import { formatByteSize, updateQueryParam } from "mazey";

export function buildOssUploadUrl (url, target, ossId) {
  const targetUrl = updateQueryParam(url, "target", target);
  return updateQueryParam(targetUrl, "oss_id", String(ossId));
}

export function formatAssetFileSize (size) {
  if (!size) return "";
  return formatByteSize(size, { fractionDigits: 2 });
}

export function normalizeOssConfsResponse (res) {
  const data = res && res.data;
  return {
    ossConfs: Array.isArray(data && data.ossConfs) ? data.ossConfs : [],
    ret: res && res.ret,
    serverMessage: res && res.message,
  };
}
